module.exports = __webpack_public_path__ + "static/media/newton_first_law_motion.c3e06b2c.pdf";